import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale/pt-BR';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { FutProIcon } from '../../../../components/Icons/FutProIcon';
import { PickProIcon } from '../../../../components/Icons/PickProIcon';
import { Transaction } from '../../../../components/Icons/Transaction';
import Button from '../../../../components/ui/button';
import Toast from '../../../../components/ui/toast';
import {
	choosePlatform,
	CurrencyFormatter,
	sentryCapture,
	showWalletAndBalance,
} from '../../../../helpers/utils';
import { useApi } from '../../../../hooks/useApi';
import { useTokenStore } from '../../../../store/token';
import { SentryError } from '../../../../types/enums';

interface iProps {
	tabsSelect: string;
}

export const WalletBonus = ({ tabsSelect }: iProps) => {
	const api = useApi();
	const token = useTokenStore((state: any) => state.token);

	const [isLoading, setIsLoading] = useState(false);
	const [transactions, setTransactions] = useState<any[]>([]);
	const [page, setPage] = useState<number>(0);
	const [totalPages, setTotalPages] = useState<number>(0);
	const [isFirstReq, setIsFirstReq] = useState(true);
	const [hasMore, setHasMore] = useState(true);
	const pageSize = 5;

	useEffect(() => {
		if (isLoading) return;
		if (tabsSelect === 'Bônus') {
			fetchTransactions(page);
		}
	}, [page]);

	useEffect(() => {
		if (
			!isLoading &&
			tabsSelect === 'Bônus' &&
			transactions.length === 0 &&
			!isFirstReq
		) {
			fetchTransactions(page);
		}
	}, [tabsSelect]);

	const fetchTransactions = async (page: number) => {
		setIsLoading(true);
		try {
			if (totalPages !== 0) {
				if (page >= totalPages) {
					setHasMore(false);
					return;
				}
			}

			const response = await api.fetchTransactionsBonus(
				token,
				page,
				pageSize
			);
			if (!response?.success) {
				throw new Error(response.message);
			}
			setTotalPages(response.totalPages);
			setTransactions((prevTransactions: any) => [
				...prevTransactions,
				...response.data,
			]);
			if (response.currentPage >= response.totalPages) {
				setHasMore(false);
				return;
			}
			setIsFirstReq(false);
		} catch (error: any) {
			toast(<Toast variant="error">{error.message}</Toast>);
			sentryCapture(error, 'sendTokenValidation', SentryError.Error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="flex flex-col gap-3.5 mb-6">
			{transactions.map((transaction: any, index: number) => (
				<div
					key={index}
					className="flex flex-row py-3 px-5 items-center justify-between rounded-lg bg-custom-gray7"
				>
					<Transaction classname="mr-3.5" />
					<div className="w-full flex flex-row items-center justify-between gap-1">
						<div className="w-2/5">
							<p
								className={
									'text-sm text-left text-custom-gray1 font-bahnschrift ' +
									(transaction.isCanceled
										? 'line-through'
										: '')
								}
							>
								{transaction.historic}
							</p>
							<p className="text-xs text-left text-custom-gray4 font-bahnschrift">
								{transaction.transcationAt &&
									format(
										transaction.transcationAt,
										"dd 'de' MMMM, HH:mm",
										{ locale: ptBR }
									)}
							</p>
						</div>
						<div
							className={
								'w-1/3 text-sm text-right font-bahnschrift flex justify-end items-center gap-1 ' +
								(transaction.isDebit
									? 'text-error'
									: 'text-[#2CDA67] ') +
								(transaction.isCanceled ? 'line-through' : '')
							}
						>
							{showWalletAndBalance() ? (
								'R$ '
							) : choosePlatform() ? (
								<PickProIcon
									style="w-3.5 h-3.5"
									color={
										transaction.isDebit
											? choosePlatform()
												? '#35168C'
												: '#DF1737'
											: '#2CDA67'
									}
								/>
							) : (
								<FutProIcon
									style="w-3.5 h-3.5"
									color={
										transaction.isDebit
											? choosePlatform()
												? '#35168C'
												: '#DF1737'
											: '#2CDA67'
									}
								/>
							)}
							{CurrencyFormatter(
								Number(transaction.transcationValue)
							)}
						</div>
					</div>
				</div>
			))}
			{hasMore && (
				<Button
					onClick={() => {
						setPage(page + 1);
					}}
					isLoading={isLoading}
					className="py-4"
				>
					Carregar mais
				</Button>
			)}
		</div>
	);
};
